<template>
    <AuthLayout>
        <div
            class="mt-8 flex w-full flex-col items-center overflow-hidden bg-white p-6 shadow-xl sm:mt-14 sm:max-w-md sm:rounded-lg"
        >
            <div class="-mt-1 h-[240px] w-[240px]">
                <img
                    src="https://d5aoblv5p04cg.cloudfront.net/application/images/auth/registration-email.png"
                    class="ml-[10px] mt-[10px] h-full w-full"
                    alt="Rhizom Illustration"
                />
            </div>

            <div class="mt-[14px] text-xl font-bold text-gray-800">
                {{ $t("vue.thank_you_for_signing_up") }}
            </div>

            <div
                class="mt-3 max-w-[360px] text-center text-sm font-medium text-gray-800"
            >
                {{ $t("vue.verify_email_message") }}
            </div>

            <div class="mt-5 max-w-[260px] text-center text-sm text-gray-500">
                {{ $t("vue.didnt_receive_verification_email") }}
            </div>

            <div
                v-if="verificationLinkSent"
                class="-mb-2 mt-5 text-center text-sm font-medium text-green-600"
            >
                {{ $t("vue.new_verification_link_sent") }}
            </div>

            <form @submit.prevent="submit">
                <AtomicButton
                    class="mt-9"
                    :disabled="form.processing"
                    type="submit"
                >
                    {{ $t("vue.resend_verification_email") }}
                </AtomicButton>
                <div class="mb-2 flex justify-center">
                    <inertia-link
                        :href="route('logout')"
                        method="post"
                        as="button"
                        class="mt-6 pb-2 text-xs font-medium text-custom-blue-500 hover:text-custom-blue-600"
                        >{{ $t("vue.log_out") }}</inertia-link
                    >
                </div>
            </form>
        </div>
    </AuthLayout>
</template>

<script setup lang="ts">
import route from "ziggy-js";
import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    status: {
        type: String,
        default: "",
    },
});

const form = useForm({});

const submit = async () => {
    form.post(route("verification.send"));
};

const verificationLinkSent = computed(() => {
    return props.status === "verification-link-sent";
});
</script>
